// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Price = require("./Price.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PriceRangeCriteria_priceRange_graphql = require("../../../__generated__/PriceRangeCriteria_priceRange_graphql.bs.js");

let convertFragment = PriceRangeCriteria_priceRange_graphql.Internal.convertFragment;

function PriceRangeCriteria(props) {
  let match = RescriptRelay_Fragment.useFragment(PriceRangeCriteria_priceRange_graphql.node, convertFragment, props.priceRange);
  return JsxRuntime.jsx(Price.make, {
    children: match.minPrice.formatted + ` - ` + match.maxPrice.formatted + (
      props.priceType === "monthly" ? "/month" : ""
    ),
    size: props.size,
    className: props.className
  });
}

let make = PriceRangeCriteria;

exports.make = make;
/* Price Not a pure module */
